export const requireValue = <T>(value: T | undefined | null): T => {
    if (value === null || value === undefined) {
        throw new Error("value must be defined and not null");
    }
    return value;
}